import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

export const amountColors = {
  accrual: Colors.success,
  subtract: Colors.error
}

export const amountIcons = {
  accrual: icons.add,
  subtract: icons.remove
}

export const billingsStatuses = {
  pending: {
    color: Colors.info,
    icon: icons.query_builder
  },
  refunded: {
    color: Colors.info,
    icon: icons.replay
  },
  complete: {
    color: Colors.success,
    icon: icons.done
  },
  invalid: {
    color: Colors.error,
    icon: icons.clear
  },
  total: {
    color: Colors.grey,
    icon: icons.equalizer
  }
}

export function formatPriceCalculation(value, separator = '\n') {
  const result = []

  const prefix = `${Services.billings}.labels.data.priceCalculation`
  for (const { segmentPrice, segmentCount, threshold, sum } of value) {
    const item = []
    item.push(`${this.getTranslate(`${prefix}.segmentPrice`)}: ${getPrice(segmentPrice)}`)
    item.push(`${this.getTranslate(`${prefix}.segmentCount`)}: ${segmentCount}`)
    item.push(`${this.getTranslate(`${prefix}.threshold`)}: ${threshold}`)
    item.push(`${this.getTranslate(`${prefix}.sum`)}: ${getPrice(sum)}`)
    result.push(item.join(' | '))
  }

  return result.join(`${separator}`)
}
